import { useToast } from '@shared/components/toast';
import { useEmailThreadContext } from '@shared/contexts/pluginContexts/EmailThreadContext';
import { PromptContextProvider } from '@shared/contexts/PromptContext';
import { ActionRegistryContextProvider } from '@shared/plugin/contexts/ActionRegistryContext';
import { FeedContextProvider } from '@shared/plugin/contexts/FeedContext';
import { BuildJobHandler } from '@shared/plugin/features/Feed/hooks/useSuggestedActions';
import { useBuildFromEmail } from '@shared/plugin/hooks/useBuildFromEmail';

const BUILD_NOT_STARTED_MESSAGE = "Couldn't start a build from this email.";

export function EmailThreadFeedProvider({
  children,
}: {
  children: JSX.Element;
}) {
  const { hasUnconfirmedOrder, hasUnconfirmedQuote, thisItem } =
    useEmailThreadContext();
  const { buildFromEmail } = useBuildFromEmail();
  const { sendToast } = useToast();

  const sendBuildErrorToast = (message: string) =>
    sendToast(message, { variant: 'error', compact: true });

  const handleSendToVooma: BuildJobHandler = async (jobType, buildHint) => {
    try {
      const job = await buildFromEmail(jobType, buildHint);
      if (!job) sendBuildErrorToast(BUILD_NOT_STARTED_MESSAGE);
      return { hasStarted: Boolean(job) };
    } catch (e) {
      sendBuildErrorToast(
        e instanceof Error ? e.message : BUILD_NOT_STARTED_MESSAGE
      );
      return { hasStarted: false };
    }
  };

  return (
    <ActionRegistryContextProvider>
      <PromptContextProvider>
        <FeedContextProvider
          disableTransactions={!thisItem?.id}
          handleSendToVooma={handleSendToVooma}
          hasUnconfirmedOrder={hasUnconfirmedOrder}
          hasUnconfirmedQuote={hasUnconfirmedQuote}
        >
          {children}
        </FeedContextProvider>
      </PromptContextProvider>
    </ActionRegistryContextProvider>
  );
}
